export async function getData(minisiteCategoryId, minisiteId, langShort) {
	const req = await fetch(
		`${
			import.meta.env.DEV ? 'http://localhost:5712' : 'https://forms-api.webcloud.cloud'
		}/data/${minisiteCategoryId}/${minisiteId}`,
		{
			headers: {
				'x-language': langShort,
			},
		}
	)
	const res = await req.json()

	if (res.success) {
		return res.data
	}

	throw new Error('Failed to getData')
}
